import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Drawer } from "../../../../components/Drawer";
import { entryActions } from "../../../../redux/entry/entry.slice";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { userSliceSelectors } from "../../../../redux/user/user.selector";
import { EntryTableSettingsColumns } from "./EntryTableSettingsColumns";

type EntryTableSettingsModalProps = {
  open: boolean;
  onClose: VoidFunction;
};

export const EntryTableSettingsDrawer: React.FC<
  EntryTableSettingsModalProps
> = ({ open, onClose }) => {
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const { t } = useTranslation(undefined, {});
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(entryActions.getUserTableSettings({ userId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Drawer
      destroyOnHidden
      open={open}
      onClose={onClose}
      title={t("entries.table.settings.columns.header")}
      width={"40rem"}
    >
      <EntryTableSettingsColumns open={open} />
    </Drawer>
  );
};
